__turbopack_context__.v({
  "active": "ProductCarousel-module__Rijt2a__active",
  "bottomCenter": "ProductCarousel-module__Rijt2a__bottomCenter",
  "bottomLeft": "ProductCarousel-module__Rijt2a__bottomLeft",
  "bottomRight": "ProductCarousel-module__Rijt2a__bottomRight",
  "ctaNavWrapper": "ProductCarousel-module__Rijt2a__ctaNavWrapper",
  "cursorTracked": "ProductCarousel-module__Rijt2a__cursorTracked",
  "cursorTracker": "ProductCarousel-module__Rijt2a__cursorTracker",
  "description": "ProductCarousel-module__Rijt2a__description",
  "dot": "ProductCarousel-module__Rijt2a__dot",
  "embla": "ProductCarousel-module__Rijt2a__embla",
  "emblaContainer": "ProductCarousel-module__Rijt2a__emblaContainer",
  "emblaSlide": "ProductCarousel-module__Rijt2a__emblaSlide",
  "hidden": "ProductCarousel-module__Rijt2a__hidden",
  "imageContainer": "ProductCarousel-module__Rijt2a__imageContainer",
  "indicatorWrapper": "ProductCarousel-module__Rijt2a__indicatorWrapper",
  "isActive": "ProductCarousel-module__Rijt2a__isActive",
  "mainImage": "ProductCarousel-module__Rijt2a__mainImage",
  "mainVideo": "ProductCarousel-module__Rijt2a__mainVideo",
  "middleCenter": "ProductCarousel-module__Rijt2a__middleCenter",
  "middleLeft": "ProductCarousel-module__Rijt2a__middleLeft",
  "middleRight": "ProductCarousel-module__Rijt2a__middleRight",
  "navigation": "ProductCarousel-module__Rijt2a__navigation",
  "nearIndicator": "ProductCarousel-module__Rijt2a__nearIndicator",
  "objectBottom": "ProductCarousel-module__Rijt2a__objectBottom",
  "objectFitContain": "ProductCarousel-module__Rijt2a__objectFitContain",
  "objectFitCover": "ProductCarousel-module__Rijt2a__objectFitCover",
  "progress": "ProductCarousel-module__Rijt2a__progress",
  "root": "ProductCarousel-module__Rijt2a__root",
  "slideTextWrapper": "ProductCarousel-module__Rijt2a__slideTextWrapper",
  "stickyWrapper": "ProductCarousel-module__Rijt2a__stickyWrapper",
  "title": "ProductCarousel-module__Rijt2a__title",
  "topCenter": "ProductCarousel-module__Rijt2a__topCenter",
  "topLeft": "ProductCarousel-module__Rijt2a__topLeft",
  "topRight": "ProductCarousel-module__Rijt2a__topRight",
});
